import React from 'react';
import { TextField } from 'react-admin';
import { ZippityDatagrid } from '../components';
import BulkDeleteButton from '../components/BulkDeleteButton';
import ListWithCSVImport from '../components/ListWithCSVImport';

export const PriceSheetList = ({ classes, ...props }) => (
  <div>
    <ListWithCSVImport
      {...props}
      bulkActionButtons={<BulkDeleteButton />}
      perPage={50}
    >
      <ZippityDatagrid>
        <TextField source="price_sheet_name" />
        <TextField source="price_sheet_id" />
      </ZippityDatagrid>
    </ListWithCSVImport>
  </div>
);
